import { render, staticRenderFns } from "./LoginRecord.vue?vue&type=template&id=1ecd56f8&scoped=true&"
import script from "./LoginRecord.vue?vue&type=script&lang=js&"
export * from "./LoginRecord.vue?vue&type=script&lang=js&"
import style0 from "./LoginRecord.vue?vue&type=style&index=0&id=1ecd56f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd56f8",
  null
  
)

export default component.exports